export default __webpack_public_path__ + "static/media/5w-30_Qualia_L.c650ba8e.png";